import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Result,
	Button,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'categoryList':[],
			'filter':{
				'category_id':0,
				'is_points':1,
			},
			
			'list':[],
			'pageInfo':{
				'url_list':[],
			},
		};
	}
	
	componentDidMount()
	{
		document.title = '积分商城 - ' + CommonValue.get('site_name');
		
		this.getCategoryList();
		//this.getList();
	}
	
	getCategoryList()
	{
		let url = pcUrl('goods','categoryList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'categoryList':data,
				},()=>{
					if(!this.state.filter['category_id'])
					{
						this.state.filter['category_id'] = data[0]['category_id'];
						this.getList();
					}
				});
			});
	}
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = 12;
		
		let url = pcUrl('goods','index');
		let param = this.state.filter;
		param.page = page;
		param.page_size = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'list':data['list'],
					'pageInfo':data['page_info'],
				});
			});
	}
	
	render()
	{
		return (
		<div>
			<div className="goods-right" style={{'width':'100%'}}>
				<div className="goods-category">
					<dl>
						<dt>
							分类：
						</dt>
						<dd>
							{this.state.categoryList.map((row,index)=>(
								<a href="javascript:;" className={this.state.filter['category_id'] == row['category_id'] ? 'now':''} onClick={()=>{this.state.filter['category_id'] = row['category_id']; this.getList();}}>{row['category_name']}</a>
							))}
						</dd>
					</dl>
				</div>
				<div className="goods-list" style={{'margin':'0 1em'}}>
					{this.state.list.map((row,index)=>(
						<dl onClick={()=>this.props.history.push('/user/pointsGoods/'+row['goods_id'])}>
							<dd>
								<a href="javascript:;" title={row['goods_name']}>
									<img src={row['goods_thumb']['image_name']} />
								</a>
							</dd>
							<dt>
								<a href="javascript:;">{row['goods_name']}</a>
							</dt>
							<dd>
								<span className="float-right text-gray"> 销量{row['goods_salenum']}件 </span>
								<span className="text-red">
									{row['goods_points']}积分
								</span>
							</dd>
						</dl>
					))}
					<div className="clear"></div>
					{!+this.state.pageInfo.total ? (
						<div className="text-center padding-20 text-gray">暂无数据</div>
					):(
						<>
							{this.state.pageInfo.last_page > 1 ? (
								<div className="page text-center">
									<ul>
										{this.state.pageInfo['current_page'] != 1 ? (
										<li> <a href="javascript:;" onClick={()=>this.getList(1)}>上一页</a> </li>
										):''}
										
										{Object.keys(this.state.pageInfo['url_list']).map(page=>(
											<>
												{this.state.pageInfo['current_page'] == page ? (
													<li> <span className="now">{page}</span> </li>
												):(
													<li> <a href="javascript:;" onClick={()=>this.getList(page)}>{page}</a> </li>
												)}
											</>
										))}
										
										{this.state.pageInfo['current_page'] != this.state.pageInfo['last_page'] ? (
										<li> <a href="javascript:;" onClick={()=>this.getList(this.state.pageInfo['current_page'] + 1)}>下一页</a> </li>
										):''}
									</ul>
								</div>
							):''}
							<div className="height-20"></div>
						</>
					)}
				</div>
			</div>
		</div>
		);
	}
}


